


import { Component, OnInit, Inject, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import * as moment from 'moment';

import { CommonService, AlertService, AdminService, LeadService, ProjectService } from '../../../_services/';


import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-schedule-walk-through-dialog',
  templateUrl: './schedule-walk-through-dialog.component.html',
  styleUrls: ['./schedule-walk-through-dialog.component.scss']
})

export class ScheduleWalkThroughDialogComponent implements OnInit {

  scheduleWalkForm:FormGroup;
  submitted:Boolean=false;
  
  timeList:any[] = [
    '01:00 AM', '01:30 AM', '02:00 AM', '02:30 AM', '03:00 AM', '03:30 AM', '04:00 AM', '04:30 AM',
    '05:00 AM', '05:30 AM', '06:00 AM', '06:30 AM', '07:00 AM', '07:30 AM', '08:00 AM', '08:30 AM',
    '09:00 AM', '09:30 AM', '10:00 AM', '10:30 AM', '11:00 AM', '11:30 AM', '12:00 PM', '12:30 PM',
    '01:00 PM', '01:30 PM', '02:00 PM', '02:30 PM',
    '03:00 PM','03:30 PM','04:00 PM', '04:30 PM','05:00 PM', '05:30 PM',  '06:00 PM',
    '06:30 PM','07:00 PM','07:30 PM', '08:00 PM','08:30 PM', '09:00 PM',  '09:30 PM',
    '10:00 PM','10:30 PM','11:00 PM', '11:30 PM','12:00 PM', '12:30 PM'
  ]
  private subscription: Subscription;
  private subscription2: Subscription;
  private subscription3: Subscription;
  constructor(
    public dialogRef: MatDialogRef<ScheduleWalkThroughDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private _common : CommonService,
    private _alert : AlertService,
    private _admin : AdminService,
    private _toastr : ToastrService,
    private _lead : LeadService,
    private _project: ProjectService
  ) { }

  ngOnInit() {
    this.scheduleWalkForm = this.fb.group({
      date1: ["", []],
      time1: ["", []],
      date2: ["", []],
      time2: ["", []],
      date3: ["", []],
      time3: ["", []],
      note: ["", []]
    }) 
    
  }
  
  hideAddNewJobFunctionDialog(){
    this.dialogRef.close();
  }

  get fval() {
    return this.scheduleWalkForm.controls;
  }

  onFormSubmit():void {
    this.submitted = true;
    if (this.scheduleWalkForm.invalid) {
      return;
    } 
    let form = this.scheduleWalkForm.value;
    form.uid = localStorage.getItem('uid');
    if((form.date1 && !form.time1) || (!form.date1 && form.time1)){
      this._toastr.error("Please select both date and time for date 1","",{ timeOut: 4000 });
      return;
    }
    if((form.date2 && !form.time2) || (!form.date2 && form.time2)){
      this._toastr.error("Please select both date and time for date 2","",{ timeOut: 4000 });
      return;
    }
    if((form.date3 && !form.time3) || (!form.date3 && form.time3)){
      this._toastr.error("Please select both date and time for date 3","",{ timeOut: 4000 });
      return;
    }

    this._common.showLoader(true);
    //Code to send email
    this.subscription = this._lead.getContactDetail(this.data.owner_contact_id).subscribe(designer=>{
      const id = `pm2_schedule_walk_through`
      this.subscription2 = this._project.getEmailRecipient(id).subscribe(emailRes=>{
        const emails = emailRes.docs.map(doc => doc.data());
        this.subscription3 = this._project.getSystemMode().subscribe(system=>{
          const systemData = system.map(item => item.payload.doc.data());
          const baseUrlObj = systemData.filter(item=> item.hasOwnProperty("base_url"));
          const mode:any = systemData.filter(item=> item.hasOwnProperty("mode"));
          
          const designerEmail = designer.payload.data()['email'] ? designer.payload.data()['email'] :'';
          const cc = mode[0].mode==="Live" ? emails[0]['live_receipients']+','+designerEmail : emails[0]['dev_receipients']+','+emails[0]['dev_designers'];
          const mailBody = {
            to : 'rs@leichtnewyork.com',
            subject :`${this.data.contact_first_name} ${this.data.contact_last_name} - ${this.data.project_name} - Step 2 - Walk-Through Request`,
            body : `Name: ${this.data.contact_first_name} ${this.data.contact_last_name}<br/><br/> Designer: ${designer.payload.data()['first_name']} ${designer.payload.data()['last_name']} <br/><br/> Project Address: ${this.data.project_address}<br/><br/>Preferred Walk-Through Date(s):<br/> - ${form.date1 ? moment(form.date1).format('MM/DD/YYYY') :''} ${form.time1} <br/> - ${form.date2 ? moment(form.date2).format('MM/DD/YYYY') : ''} ${form.time2} <br/> - ${form.date3 ? moment(form.date3).format('MM/DD/YYYY') : ''} ${form.time3} <br/><br/>  Notes: ${form.note} <br/><br/>Account: ${baseUrlObj[0]['base_url']}contact/${this.data.contact_id} <br/><br/>Project: ${baseUrlObj[0]['base_url']}project/${this.data.project_id}<br/><br/><br/>Automated email sent via RS`,
            cc: cc
          } 
          
          this._project.initEmail(mailBody).subscribe(res => {
            if(res){
              this._common.showLoader(false);
              this._toastr.success(res.message,"",{ timeOut: 4000 });
              this.dialogRef.close();
            }
          },err=>{
          this._common.showLoader(false);
          this._toastr.error(`${err && err.error && err.error.message? err.error.message :  'Something went wrong!'}`,"",{ timeOut: 4000 });
          }) 

        },err=>{
          this._common.showLoader(false);
          this._toastr.error(`${err && err.error  && err.error.message? err.error.message :  'Something went wrong!'}`,"",{ timeOut: 4000 });      
        })

        // const designerEmail = designer.payload.data()['email'] ? designer.payload.data()['email'] :''; //
        // const cc = res[0].payload.doc.data()['dev_designers']+','+designerEmail;
        
      },err=>{
        this._common.showLoader(false);
        this._toastr.error(`${err && err.error  && err.error.message? err.error.message :  'Something went wrong!'}`,"",{ timeOut: 4000 });
      })
    
    },err=>{
      this._common.showLoader(false);
      this._toastr.error(`${err && err.error  && err.error.message? err.error.message :  'Something went wrong!'}`,"",{ timeOut: 4000 });

    })
  }

  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
    if(this.subscription2) this.subscription2.unsubscribe();
    if(this.subscription3) this.subscription3.unsubscribe();
  }


}